import { Box } from "@mui/material";
import { MouseEventHandler, ReactNode } from "react";
import { buttonStyleProps } from "../theme/main";

type ButtonProps = {
  children: ReactNode;
  ariaLabel?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  sx?: Record<string, any>;
};

export function Button({ children, ariaLabel, onClick, sx }: ButtonProps) {
  return (
    <Box
      component="button"
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      sx={{
        ...buttonStyleProps,
        ...{
          border: 0,
          cursor: "pointer",
          fontFamily: "inherit",
          backgroundColor: "transparent",
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
